export default __webpack_public_path__ + "static/media/30.6839c32f.svg";